import { defineI18nConfig } from "#imports";
export default () => ({
	numberFormats: {
		de: { currency: {
			style: "currency",
			currency: "EUR"
		} },
		en: { currency: {
			style: "currency",
			currency: "EUR"
		} }
	},
	datetimeFormats: {
		de: { short: {
			year: "numeric",
			month: "2-digit",
			day: "2-digit"
		} },
		en: { short: {
			year: "numeric",
			month: "long",
			day: "2-digit"
		} }
	}
});
